<template>
    <div>
        <el-tabs
                v-model="activeName"
                class="common-el-tabs"
                @tab-click="$refs[activeName].getList()"
                type="card">
            <el-tab-pane v-if="permissions.osm_audit_waning_exception" label="报警" name="warn">
                <comp-warn-list ref="warn" class="common-el-tab-flex"/>
            </el-tab-pane>
            <el-tab-pane v-if="permissions.osm_audit_waning_exception" class="common-el-tab-flex" label="异常"
                         name="exception">
                <comp-exception-list ref="exception" class="common-el-tab-flex"/>
            </el-tab-pane>
            <!--<el-tab-pane class="common-el-tab-flex" label="大额提现审批"></el-tab-pane>-->
            <!--<el-tab-pane class="common-el-tab-flex" label="完全提豆"></el-tab-pane>-->
            <!--<el-tab-pane class="common-el-tab-flex" label="提豆信息关联账号"></el-tab-pane>-->
        </el-tabs>
    </div>
</template>
<script>
    import {mapState} from 'vuex'
    import compWarnList from './compWarnList'
    import compExceptionList from './compExceptionList'

    export default {
        components: {
            compWarnList,
            compExceptionList
        },
        data() {
            return {
                name: ['warn', 'exception'],
                activeName: 'warn',
            }
        },
        computed: {
            ...mapState('login', ['permissions'])
        },
        mounted() {
            let name = [];
            for (let i in this.$refs) {
                if (this.name.indexOf(i) > -1) {
                    name.push(i)
                }
            }
            this.activeName = name[0];
            this.$refs[this.activeName].getList()
        },
        methods: {}
    }
</script>
